import moment from 'moment-timezone';
/*
const FULLYEAR = 'DD.MM.YYYY';
const FULLDATETIME = 'DD.MM.YYYY HH:mm:ss';
const DATETIME = 'DD.MM.YYYY HH:mm';
*/
class Timeformat {

    constructor(myMoment) {

        this.myMoment = myMoment;

        this.fullDate = 'DD.MM.YYYY';
        this.monthYear = 'MM.YYYY';
        this.fullTime = 'HH:mm:ss';
        this.hourMinute = 'HH:mm';
        this.datetime = 'DD.MM.YYYY HH:mm';
        this.fullTimeWithHundredths = 'HH:mm:ss.SSS';
        this.datetimeWithHundredths = 'DD.MM.YYYY HH:mm:ss.SSS';

    }

    /**
     * @param unixtime
     * @returns {Timeformat}
     */
    static fromUnix(unixtime) {

        let m = null;

        if (unixtime < 1000000000) {
            m = null;
        } else {
            // Moment handles milliseconds if the number is large enough.
            // If it's in seconds (10 digits), we convert it to milliseconds.
            let timestamp = parseInt(unixtime);
            if (timestamp < 10000000000) {
                timestamp = timestamp * 1000;
            }
            m = moment(timestamp);
        }

        return (m !== null) ? new Timeformat(m) : null;

    }

    getFullYear() {

        if (this.myMoment) return this.myMoment.format(this.fullDate);

    }

    getFullDateTime(tz) {

        if (this.myMoment) {
            if (tz) {
                return this.myMoment.tz(tz).format(this.fullDate + ' ' + this.fullTime);
            } else {
                return this.myMoment.format(this.fullDate + ' ' + this.fullTime);
            }
        }

        return null;

    }

    getDateTime(tz) {

        if (this.myMoment) {
            if (tz) {
                return this.myMoment.tz(tz).format(this.datetime);
            } else {
                return this.myMoment.format(this.datetime);
            }
        }

        return null;

    }

    getDateTimeWithHundredths(tz) {

        if (this.myMoment) {
            if (tz) {
                return this.myMoment.tz(tz).format(this.datetimeWithHundredths);
            } else {
                return this.myMoment.format(this.datetimeWithHundredths);
            }
        }

        return null;

    }

    getFormatedDate(format, tz = null) {

        if (this.myMoment && format) {
            if (tz) {
                return this.myMoment.tz(tz).format(format);
            } else {
                return this.myMoment.format(format);
            }
        }

        return null;

    }

    static formatTimerange(millisecs) {

        let m = moment.duration(millisecs);

        //return m.humanize();
        if (m.months() > 0) return m.months() + ' mon ' + m.days() + ' days ' + m.hours() + ' hours';

        if (m.days() > 0) return m.days() + ' days ' + m.hours() + ' hours';

        if (m.hours() > 0) return m.hours() + ' hours ' + m.minutes() + ' min';

        return m.minutes() + ' min';

    }

}

export default Timeformat;